import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Check } from 'lucide-react';

export default function Pricing() {
  return (
    <div className="min-h-screen bg-white py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-5xl font-bold text-center text-slate-900 mb-8">
          Precios Simples y Transparentes
        </h1>
        <p className="text-xl text-center text-slate-600 mb-20 max-w-3xl mx-auto">
          Elige el plan que mejor se adapte al tamaño de tu clínica
        </p>

        <div className="grid md:grid-cols-3 gap-8">
          {/* Starter */}
          <div className="bg-white rounded-2xl border-2 border-slate-200 p-8 hover:shadow-xl transition-shadow">
            <h3 className="text-2xl font-bold text-slate-900 mb-2">Starter</h3>
            <p className="text-slate-600 mb-6">Perfecto para clínicas pequeñas</p>
            <div className="mb-6">
              <span className="text-5xl font-bold text-slate-900">$29</span>
              <span className="text-slate-600">/mes</span>
            </div>
            <ul className="space-y-3 mb-8">
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-600" />
                <span className="text-slate-700">Hasta 50 casos/mes</span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-600" />
                <span className="text-slate-700">Timeline en tiempo real</span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-600" />
                <span className="text-slate-700">Códigos NFC</span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-600" />
                <span className="text-slate-700">Soporte por email</span>
              </li>
            </ul>
            <Link to="/clinic/login">
              <Button className="w-full" variant="outline">
                Empezar Ahora
              </Button>
            </Link>
          </div>

          {/* Professional */}
          <div className="bg-blue-600 rounded-2xl border-2 border-blue-600 p-8 shadow-xl relative">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-1 rounded-full text-sm font-semibold">
              Más Popular
            </div>
            <h3 className="text-2xl font-bold text-white mb-2">Professional</h3>
            <p className="text-blue-100 mb-6">Para clínicas en crecimiento</p>
            <div className="mb-6">
              <span className="text-5xl font-bold text-white">$79</span>
              <span className="text-blue-100">/mes</span>
            </div>
            <ul className="space-y-3 mb-8">
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-400" />
                <span className="text-white">Hasta 200 casos/mes</span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-400" />
                <span className="text-white">Timeline en tiempo real</span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-400" />
                <span className="text-white">Códigos NFC ilimitados</span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-400" />
                <span className="text-white">Soporte prioritario</span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-400" />
                <span className="text-white">Análisis y reportes</span>
              </li>
            </ul>
            <Button className="w-full bg-white text-blue-600 hover:bg-slate-50">
              Empezar Ahora
            </Button>
          </div>

          {/* Enterprise */}
          <div className="bg-white rounded-2xl border-2 border-slate-200 p-8 hover:shadow-xl transition-shadow">
            <h3 className="text-2xl font-bold text-slate-900 mb-2">Enterprise</h3>
            <p className="text-slate-600 mb-6">Para grandes clínicas y cadenas</p>
            <div className="mb-6">
              <span className="text-5xl font-bold text-slate-900">Custom</span>
            </div>
            <ul className="space-y-3 mb-8">
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-600" />
                <span className="text-slate-700">Casos ilimitados</span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-600" />
                <span className="text-slate-700">Múltiples ubicaciones</span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-600" />
                <span className="text-slate-700">Integración con sistemas</span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-600" />
                <span className="text-slate-700">Gerente de cuenta dedicado</span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-600" />
                <span className="text-slate-700">Soporte 24/7</span>
              </li>
            </ul>
            <Link to="/contact">
              <Button className="w-full" variant="outline">
                Contactar Ventas
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
